import queryString from 'query-string';
export var Platform;
(function (Platform) {
    Platform["DASHBOARD"] = "dashboard";
    Platform["EDITOR"] = "editor";
    Platform["STANDALONE"] = "standalone";
})(Platform || (Platform = {}));
function isValidHttpUrl(string) {
    var url;
    try {
        url = new URL(string);
    }
    catch (_) {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
}
var isBrowser = function () { return typeof window !== 'undefined'; };
var installerUrl = isBrowser()
    ? window.location.origin + "/installer/install?appId="
    : 'https://www.wix.com/installer/install?appId=';
var ClientSDK = /** @class */ (function () {
    function ClientSDK(platform, metaSiteId, editorSDK, onEditorFinishAdd) {
        var _this = this;
        this.handleRequiredActionForEditor = function (requiredActionsMessage) {
            var requiredAction = requiredActionsMessage &&
                requiredActionsMessage.data &&
                requiredActionsMessage.data.requiredActions;
            var actionType = requiredAction && requiredAction.actionType;
            var appId = requiredActionsMessage &&
                requiredActionsMessage.data &&
                requiredActionsMessage.data.appId;
            var appVersion = requiredActionsMessage &&
                requiredActionsMessage.data &&
                requiredActionsMessage.data.appVersion;
            var isValid = isValidHttpUrl(requiredAction === null || requiredAction === void 0 ? void 0 : requiredAction.link);
            if (_this.platform === Platform.DASHBOARD) {
                if ((actionType === 'EDITOR' || (actionType === 'CREATE_SITE')) && isValid) {
                    _this.closeInstaller();
                    window.open(requiredAction.link);
                }
                else if ((actionType === 'DASHBOARD') && isValid) {
                    window.location.href = requiredAction.link;
                    _this.closeInstaller();
                }
            }
            else if (_this.platform === Platform.EDITOR) {
                if (actionType === 'EDITOR') {
                    _this.editorSDK &&
                        _this.editorSDK.addApp({
                            appDefId: appId,
                            appVersion: appVersion,
                        });
                    _this.onEditorFinishAdd && _this.onEditorFinishAdd(appId);
                    _this.closeInstaller();
                }
                else if ((actionType === 'DASHBOARD') && isValid) {
                    _this.closeInstaller();
                    window.open(requiredAction.link);
                }
            }
            else if (isValid) {
                //standalone
                window.location = requiredAction && requiredAction.link;
                _this.closeInstaller();
            }
        };
        this.handleRequiredActionForToken = function (requiredActionsMessage, actionType) {
            var requiredActions = requiredActionsMessage &&
                requiredActionsMessage.data &&
                requiredActionsMessage.data.requiredActions;
            var requiredAction = requiredActions &&
                requiredActions.find(function (action) { return action.actionType === actionType; });
            var appId = requiredActionsMessage &&
                requiredActionsMessage.data &&
                requiredActionsMessage.data.appId;
            var appVersion = requiredActionsMessage &&
                requiredActionsMessage.data &&
                requiredActionsMessage.data.appVersion;
            var isValid = isValidHttpUrl(requiredAction === null || requiredAction === void 0 ? void 0 : requiredAction.link);
            if (_this.platform === Platform.DASHBOARD) {
                if ((actionType === 'EDITOR' || (actionType === 'CREATE_SITE')) && isValid) {
                    _this.closeInstaller();
                    window.open(requiredAction.link);
                }
                else if ((actionType === 'DASHBOARD') && isValid) {
                    window.location.href = requiredAction.link;
                    _this.closeInstaller();
                }
            }
            else if (_this.platform === Platform.EDITOR) {
                if (actionType === 'EDITOR') {
                    _this.editorSDK &&
                        _this.editorSDK.addApp({
                            appDefId: appId,
                            appVersion: appVersion,
                        });
                    _this.onEditorFinishAdd && _this.onEditorFinishAdd(appId);
                    _this.closeInstaller();
                }
                else if ((actionType === 'DASHBOARD') && isValid) {
                    _this.closeInstaller();
                    window.open(requiredAction.link);
                }
            }
            else if (isValid) {
                //standalone
                window.location = requiredAction.link;
                _this.closeInstaller();
            }
        };
        this.handleRequiredAction = function (requiredAction, message) {
            var isValid = isValidHttpUrl(requiredAction === null || requiredAction === void 0 ? void 0 : requiredAction.link);
            if (_this.platform === Platform.DASHBOARD) {
                if (isValid && ((requiredAction.actionType === 'EDITOR') || (requiredAction.actionType === 'CREATE_SITE'))) {
                    window.open(requiredAction.link);
                    _this.closeInstaller();
                }
                else if ((requiredAction.actionType === 'DASHBOARD') && isValid) {
                    window.location.href = requiredAction.link;
                    _this.closeInstaller();
                }
                else if (requiredAction.actionType === 'MANAGE_APPS') {
                    _this.goToManageApps();
                }
            }
            else if (_this.platform === Platform.EDITOR) {
                if (requiredAction.actionType === 'EDITOR') {
                    _this.editorSDK &&
                        _this.editorSDK.addApp({
                            appDefId: message && message.data.appId,
                            appVersion: message && message.data.appVersion,
                        });
                    _this.onEditorFinishAdd &&
                        _this.onEditorFinishAdd(message && message.data.appId);
                    _this.closeInstaller();
                }
                else if ((requiredAction.actionType === 'DASHBOARD') && isValid) {
                    _this.closeInstaller();
                    window.open(requiredAction.link);
                    //this.closeInstaller();
                }
                else if (requiredAction.actionType === 'MANAGE_APPS') {
                    _this.goToManageApps();
                }
            }
            else if (isValid) {
                //standalone
                window.location = requiredAction && requiredAction.link;
                _this.closeInstaller();
            }
        };
        this.onFinishInstall = function (message) {
            var _a, _b, _c, _d, _e, _f;
            if (message.data.installStatus === 'waitForTokenReceived') {
                _this.tokenRequiredActionsMessage = message;
                return;
            }
            if (message.data.installStatus === 'getPlatform') {
                _this.installationModal.postMessage({
                    platformForInstaller: (_b = (_a = _this.tokenRequiredActionsMessage) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.platform,
                    isInUpdateFlow: (_d = (_c = _this.tokenRequiredActionsMessage) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.isInUpdateFlow,
                    isBusinessFirst: (_f = (_e = _this.tokenRequiredActionsMessage) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.isBusinessFirst,
                    src: 'installerSDK',
                }, '*');
                return;
            }
            if (message.data.installStatus === 'tokenReceived') {
                //this code will be deleted, sorry
                if (_this.requiredActionsMessage === null) {
                    _this.handleRequiredActionForToken(_this.tokenRequiredActionsMessage, _this.tokenRequiredActionsMessage.data.actionType);
                }
                else {
                    _this.handleRequiredActionForEditor(_this.requiredActionsMessage);
                }
            }
            if (message.data.installStatus === 'tokenReceivedV2') {
                _this.handleRequiredActionForToken(_this.tokenRequiredActionsMessage, message.data.actionType);
            }
            if (message.data.installStatus === 'onProvisionSuccess' ||
                message.data.installStatus === 'silentEditor') {
                _this.onInstallationSuccess &&
                    _this.onInstallationSuccess({
                        instance_id: message.data && message.data.instanceId,
                        msid: message.data && message.data.msid,
                    });
            }
            if (message.data.installStatus === 'silentEditor') {
                _this.editorSDK &&
                    _this.editorSDK.addApp({
                        appDefId: message && message.data.appId,
                        appVersion: message && message.data.appVersion,
                    });
                _this.onEditorFinishAdd &&
                    _this.onEditorFinishAdd(message && message.data.appId);
                _this.closeInstaller();
            }
            if (message.data.requiredActions) {
                var requiredAction = message.data.requiredActions;
                _this.handleRequiredAction(requiredAction, message);
            }
            else if (message.data.installStatus === 'close') {
                _this.closeInstaller();
            }
            else if ((message.data && message.data.installStatus === 'cancel') ||
                (message.data && message.data.type === 'FINISH_INSTALLATION_EMBEDDED')) {
                _this.closeInstaller();
            }
            else if (message.data && message.data.installStatus === 'fail') {
                _this.onInstallationFail({
                    reason: message.data.reason,
                });
            }
        };
        this.getMiddleCoordinate = function (popupWindowSize, screenSize) {
            return screenSize / 2 - popupWindowSize / 2;
        };
        this.installApp = function (_a) {
            var appDefId = _a.appDefId, version = _a.version, openMethod = _a.openMethod, isPremiumApp = _a.isPremiumApp, shareId = _a.shareId, onInstallationSuccess = _a.onInstallationSuccess, onInstallationFail = _a.onInstallationFail, goToManageApps = _a.goToManageApps;
            _this.openMethod = openMethod;
            _this.onInstallationSuccess = onInstallationSuccess;
            _this.onInstallationFail = onInstallationFail;
            _this.requiredActionsMessage = null;
            _this.tokenRequiredActionsMessage = null;
            if (openMethod === 'NEW_TAB' || _this.platform === 'standalone') {
                window.addEventListener('message', _this.onFinishInstall);
                var search = queryString.stringify({
                    version: version,
                    metaSiteId: _this.metaSiteId,
                    platform: _this.platform,
                    isPremiumApp: isPremiumApp,
                    shareId: shareId,
                });
                _this.frameSrc = "" + installerUrl + appDefId + "&" + search;
                _this.installationModal = window.open(_this.frameSrc);
            }
            else {
                var width = 600;
                var height = 650;
                var popupWindowTop = _this.getMiddleCoordinate(height, window.screen.height);
                var popupWindowLeft = _this.getMiddleCoordinate(width, window.screen.width);
                window.addEventListener('message', _this.onFinishInstall);
                var search = queryString.stringify({
                    version: version,
                    metaSiteId: _this.metaSiteId,
                    platform: _this.platform,
                    isPremiumApp: isPremiumApp,
                    shareId: shareId,
                    modal: true,
                });
                _this.frameSrc = "" + installerUrl + appDefId + "&" + search;
                _this.installationModal = window.open(_this.frameSrc, '_blank', "height=" + height + ",width=" + width + ",top=" + popupWindowTop + ",left=" + popupWindowLeft);
                // this.installationModal.appendChild(frame);
                // document.body.insertAdjacentElement('afterbegin', this.installationModal);
            }
        };
        this.finishEditorInstallation = function (appDefId, appVersion, options) {
            var params = appVersion !== ''
                ? { appDefId: appDefId, appVersion: appVersion, options: options }
                : { appDefId: appDefId, options: options };
            _this.editorSDK && _this.editorSDK.addApp(params);
            _this.onEditorFinishAdd && _this.onEditorFinishAdd(appDefId);
        };
        this.setMetaSiteId = function (msid) {
            _this.metaSiteId = msid;
        };
        this.platform = platform;
        this.metaSiteId = metaSiteId;
        this.editorSDK = editorSDK;
        this.requiredActionsMessage = null;
        this.tokenRequiredActionsMessage = null;
        this.frameSrc = '';
        this.onFinishInstall = this.onFinishInstall.bind(this);
        this.closeInstaller = this.closeInstaller.bind(this);
        this.handleRequiredAction = this.handleRequiredAction.bind(this);
        this.handleRequiredActionForEditor = this.handleRequiredActionForEditor.bind(this);
        this.onEditorFinishAdd =
            typeof onEditorFinishAdd === 'function'
                ? onEditorFinishAdd.bind(this)
                : undefined;
        this.setMetaSiteId = this.setMetaSiteId.bind(this);
        this.getMiddleCoordinate = this.getMiddleCoordinate.bind(this);
        this.goToManageApps = this.goToManageApps && this.goToManageApps.bind(this);
    }
    ClientSDK.prototype.closeInstaller = function () {
        window.removeEventListener('message', this.onFinishInstall);
        this.installationModal && this.installationModal.close();
        // if (this.openMethod === 'NEW_TAB' || this.platform === 'standalone') {
        //   this.installationModal && this.installationModal.close();
        // // } else if (document.getElementById('installationModal')) {
        // //   document.getElementById('installationModal').remove();
        // // }
        // }
        // else if (this.installationModal) {
        //
        // }
    };
    return ClientSDK;
}());
export { ClientSDK };
//# sourceMappingURL=installer-client-sdk.js.map